import React, { useContext } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import { ArchivalAidMetadata } from 'types';
import { GridActionButtonComponent } from 'components/grid/grid-types';
import {
  DownloadMetadaDialog,
  processRequestFileName,
} from 'components/dialog/aisuk-dialogs/download-metadata-dialog';
import { MetadataApiRoute, ReportTemplateType } from 'enums';
import { DialogContext } from 'components/dialog/dialog-context';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    navigationButton: {
      marginTop: theme.spacing(),
      alignSelf: 'baseline',
      width: '100%',
    },
  })
);

export function ArchivalAidDownload(props: GridActionButtonComponent) {
  const { item, rootArchivalAid, isEad } = props;
  const classes = useStyles();
  const { open } = useContext(DialogContext);

  const archivalAid = item as ArchivalAidMetadata;

  const handleOpenDialog = () => {
    if (isEad && rootArchivalAid) {
      open({
        initialValues: {
          fileName: `ap_${processRequestFileName(
            rootArchivalAid.evidenceNumber!
          )}.pdf`,
          data: rootArchivalAid,
          route: MetadataApiRoute.ARCHIVAL_AID,
          templateType: ReportTemplateType.ARCHIVAL_AID,
        },
        size: 'md',
        Content: (props) => (
          <DownloadMetadaDialog<ArchivalAidMetadata> {...props} />
        ),
      });
    } else {
      open({
        initialValues: {
          fileName: `ap_${processRequestFileName(
            archivalAid.evidenceNumber!
          )}.pdf`,
          data: archivalAid,
          route: MetadataApiRoute.ARCHIVAL_AID,
          templateType: ReportTemplateType.ARCHIVAL_AID,
        },
        size: 'md',
        Content: (props) => (
          <DownloadMetadaDialog<ArchivalAidMetadata> {...props} />
        ),
      });
    }
  };

  if (isEad && !rootArchivalAid) {
    return <></>;
  }

  return (
    <Button
      component="span"
      variant="outlined"
      color="primary"
      className={classes.navigationButton}
      onClick={handleOpenDialog}
    >
      Stáhnout metadata/popis
    </Button>
  );
}
